<template>
  <div> 
    <ul class="main-menu" >
      <li>
        <router-link :to="'/'">
          <div class="icon-w">
            <div :class="'os-icon os-icon-layout'"></div>
          </div>
          <span>Dashboard</span>
        </router-link>
      </li>
      <li
        class="has-sub-menu"
        v-bind:key="currentMenu.name"
        v-for="currentMenu in modules"
      >
        <a href="/">
          <div class="icon-w">
            <div :class="currentMenu.icon"></div>
          </div>
          <span>
            <span v-html="currentMenu.description"></span>
          </span>
        </a>
        <div class="sub-menu-w">
          <div class="sub-menu-header">
            <span v-html="currentMenu.description"></span>
          </div>
          <div class="sub-menu-icon">
            <i class="os-icon os-icon-layout"></i>
          </div>
          <div class="sub-menu-i">
            <ul class="sub-menu">
              <li
                v-bind:key="currentSubItem.name"
                v-for="currentSubItem in conPermisos(currentMenu.items)"
              >
                <router-link
                  :to="currentSubItem.to"
                  v-html="currentSubItem.description"
                >
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </li>
      <li>
        <a href="#" @click="logout">
          <div class="icon-w">
            <div :class="'os-icon os-icon-signs-11'"></div>
          </div>
          <span>Logout</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import UsuariosService from "@/services/accounts/UsuariosService";

export default {
  components: {},
  data() {
    return {
      user: {
        name: "",
        image: "",
        email: "",
      },
      profile: null,
    };
  },
  props: {},
  watch: {},
  computed: {
    module() {
      return this.$store.getters.module;
    },
    modules() {
      let self = this;
      let mods = [];
      if (self.profile == null) {
        return mods;
      }
      this.$store.getters.modules.forEach((element) => {
        if (self.mostrarMenu(element)) {
          mods.push(element);
        }
      });
      return mods;
    },
  },
  created() {},
  mounted() {
    let self = this;
    self.refreshProfile();
  },
  methods: {
    refreshProfile: function () {
      let self = this;
      UsuariosService.profile()
        .then((res) => {
          self.profile = res.data;
          // this.$store.commit("REFRESCAR_MENU", res.data);
        })
        .catch((err) => {});
    },
    logout: function () {
      localStorage.removeItem("token");
      localStorage.removeItem("username");
      localStorage.removeItem("name");
      localStorage.removeItem("email");
      localStorage.removeItem("image");
      localStorage.removeItem("secciones_permitidas");
      localStorage.removeItem("vistas_permitidas");
      localStorage.removeItem("ocultar_checklist_info");
      this.$store.commit("SET_LAYOUT", "clean-layout");
      document.location.href = "/";
    },
    revisarPermiso(permiso) {
      let self = this;
      if (self.profile == null) {
        return false;
      }
      if (self.profile.is_superuser) {
        return true;
      }
      if (self.profile.permisos == null) {
        return false;
      }
      var arrR = self.profile.permisos.filter(function (ele) {
        return ele == permiso;
      });
      return arrR.length > 0;
    },
    conPermisos(items) {
      let self = this;
      let _items = [];
      items.forEach((element) => {
        if (self.revisarPermiso(element.permiso) || element.permiso == null) {
          _items.push(element);
        }
      });
      return _items;
    },
    mostrarMenu: function (menu) {
      let self = this;
      let mostrar = false;
      menu.items.forEach((element) => {
        if (self.profile != null) {
          if (self.profile.is_superuser) {
            mostrar = true;
            return;
          }
        }
        if (self.revisarPermiso(element.permiso) || element.permiso == null) {
          mostrar = true;
          return;
        }
      });
      return mostrar;
    },
  },
};
</script>
